/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Totp_UnavailableInputs */

const en_error_totp_unavailable = /** @type {(inputs: Error_Totp_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticator apps aren't available right now. Try again later or use a passkey.`)
};

/**
* | output |
* | --- |
* | "Authenticator apps aren't available right now. Try again later or use a passkey." |
*
* @param {Error_Totp_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_totp_unavailable = /** @type {((inputs?: Error_Totp_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Totp_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_totp_unavailable(inputs)
});